moduleEditor = angular.module('editorEmail.controller', ['api.widget', 'factory.editorLibrary'])
moduleEditor.controller "EditorEmailCtrl", ["$scope", "$rootScope", "$state", "$timeout", "editorNavSections", "layoutEditor", "Widget", "insertBlockMenu", "Template", "ns", "Email", "editorDragPanel", "SectionEmail", "$modal", "State", "blockOverlays", "Font", "TimeMachine", "Notification", "$filter", "Parallax", "WidgetsSortHelper", "EditorLibrary", "ButtonActionsManager", "ImageInit", ($scope, $rootScope, $state, $timeout, editorNavSections, layoutEditor, Widget, insertBlockMenu, Template, ns, Email, editorDragPanel, SectionEmail, $modal, State, blockOverlays, Font, TimeMachine, Notification, $filter, Parallax, WidgetsSortHelper, EditorLibrary, ButtonActionsManager, ImageInit) ->

  stylesCallback = undefined;
  $scope.templateIsReady = false
  $rootScope.filter = $filter

  $rootScope.justclick = window.justclick

  # Template style manipulation

  loadStylesOfTemplate = (sectionId = false) ->
    Template.getStylesheet().then (response) ->
      angular.element("#tplStyles").text response
      if stylesCallback
        stylesCallback()
        stylesCallback = undefined
  loadStylesOfPublicSection = ->
    SectionEmail.getPublicSectionStylesheet().then (response) ->
      angular.element("#tplStyles").text response
  loadStyles = (sectionId = false) ->
    if $state.includes("editor.section")
      loadStylesOfPublicSection()
    else
      loadStylesOfTemplate sectionId
  destroyGetStyles = $rootScope.$on "get:styles", (data, sectionId, cb) ->
    if cb
      stylesCallback = cb
    loadStyles sectionId
  addAdditionalFonts = ->
    if Editor.mode is "editor.section"
      Editor.Instrumentations.fonts = $rootScope.sections.fonts_attributes
    if Editor.mode is "email.page.editor"
      Editor.Instrumentations.fonts = Font.defaultEmailFonts
    $rootScope.$broadcast "fontNames:loaded"

  # destroyFontsNames = $rootScope.$on "fontNames:loaded", ->
  #   Font.connectFonts Editor.Instrumentations.fonts

  # destroySectionFonts = $rootScope.$on "sectionFonts:loaded", (e, fonts) ->
  #   Font.connectFonts fonts

  # Auto start edit section

  startEditPublicSection = ->
    if Editor.mode is "editor.section"
      layout = $rootScope.Y.one(ns.sectionClass)
      editorDragPanel._onClickEditSection target: layout

  # Remove auto play on videos

  removeAutoPlay = (htmlData) ->
    if !htmlData
      return ""
    htmlData.replace new RegExp("autoplay=1", 'g'), ""

  # Disable submit forms

  preventForm = (e) ->
    e.preventDefault()

  preventFormsSubmit = ->
    angular.element("body").on "submit", "form", preventForm

  # Enable submit forms

  unbindPreventForm = ->
    angular.element("body").off "submit", "form", preventForm


  # Parse sections html

  parseHTML = (selector, htmlString) ->
    contentSectionsHTML = ""
    codeHTML = "<div class='str-bw_code-html-overlay'><img class='str-bw_code-html-overlay-icon' src='/constructor/editor/assets/images/code-overlay-icon.svg' /><div class='str-bw_code-html-overlay-text'>#{$filter('translate')('widget.code.text')}</div></div>"

    jContent = $('<div/>').html(htmlString).contents()
    jContent.find(".str-bw_code-html").html codeHTML

    if selector isnt "section" and jContent.find(selector)[0]
      return jContent.find(selector)[0].outerHTML
    if selector is "section"
      jContent.find("section").each (index, section) ->
        contentSectionsHTML += section.outerHTML
      return contentSectionsHTML

  # Insert sections html to wrapper

  setTemplateHTML = (htmlData) ->
    if Editor.mode is "editor.section"
      $("#tpl-wrapper").html htmlData
      return false
    htmlData = "<div>#{htmlData}</div>"
    contentSectionsHTML =  parseHTML "section", htmlData

    # Скрываем header и footer
#    headerHTML = parseHTML "header", htmlData
#    footerHTML = parseHTML "footer", htmlData
#    $(headerHTML).insertBefore ".str-drop-backdrop"
#    $(footerHTML).insertAfter ".str-drop-backdrop"

    $(contentSectionsHTML).insertAfter ".str-drop-backdrop"
    EditorLibrary.removeVisibilityDelay();

  # Callback after instruments initialized

  afterInstrumentsInitialized = ->
    preventFormsSubmit()
    Template.loadHTML().then (htmlData) ->
      htmlData = removeAutoPlay htmlData
      try setTemplateHTML(htmlData)                           # try set html to Template from server
      catch e then log(e)                                     # set html to Template from server
      layoutEditor.initializer $rootScope.Y                   # set Y instace to layoutEditor class
      Template.loadJSON().then (data) ->                      # load json sections and set to YUI DOM objects

        $rootScope.contentSections = _.filter data, {section_type: "default"}
        $rootScope.sections = data

        layoutEditor.setTemplateJSON data

        editorDragPanel.initSectionsPanels($rootScope.Y, Editor.mode)
        blockOverlays.init $rootScope.Y
        addAdditionalFonts()
        $rootScope.toggleCommonSections()
        layoutEditor.sectionInitializers $rootScope.Y
        $rootScope.initWidgets()
        $timeout ->
          $scope.templateIsReady = true
        , 1000
        $timeout ->
          startEditPublicSection()
    , ->
      $rootScope.alertDialog
        title: $filter("translate")("alert.editor.error")
        text: $filter("translate")("alert.editor.errorDescription")
        accept_text: "OK"
        accept: ->
          if window.justclick.currentUser.role in ["admin", "superadmin"]
            document.location.href = "/sites/constructor/admin/#/admin/dashboard/templates"
          else
            document.location.href = window.justclick.back_uri

  # Create class editor

  Editor = {}
  Editor = {
    initializer: ->

      # Get json of site and load styles

      if Editor.mode is "email.page.editor"
        Email.get($state.params.emailId).then (siteData) ->
          $rootScope.currentSite = siteData
          $rootScope.currentPage = currentPage siteData
          $rootScope.Y.one("#tpl-wrapper").section = $rootScope.currentPage
          setBgStyles()
          loadStyles()

          $rootScope.$on 'section:created', (event, sectionNode) ->
            $rootScope.initSectionWidgets(sectionNode)

        , ->
          $state.go "404"

      if Editor.mode is "editor.section"
        loadStyles()

      Editor.Instrumentations.initializer afterInstrumentsInitialized   # init instruments for editor
    mode: $state.current.name
    getSections: ->
      sections = []
      $rootScope.Y.all(ns.sectionClass).each (s) ->
        # Установим правильную секцию при получении списка секций, если необходимо
        previousSection = layoutEditor.getRootScopeParameter('previousSection', s.section.id);
        if not s.section.removed and previousSection? and not _.isEqual(previousSection, s.section)
          s.section = previousSection;

        sections.push s.section
      sections
    destroy: ->
      layoutEditor.destroy()
  }

  # Editor instrumentations

  widgetsForEmail = [
    "image",
    "text",
    "headline_h1",
    "headline_h2",
    "headline_h3",
    "button",
    "spacer",
    "line",
    "list",
    "code",
  ]

  Editor.Instrumentations = {
    initializer: (cb) ->
      self = @

      widgetsTypesSortMap = [
        'headline_h1','headline_h2','headline_h3',
        'text', 'spacer', 'subscribe_form',
        'image', 'video', 'button',
        'list', 'timer', 'navigation',
        'link', 'review', 'card',
        'product', 'slider', 'gallery',
        'table', 'line', 'map',
        'social', 'facebook_comment', 'code',
      ];

      Widget.getAll().then (widgetsData) ->
        _.each widgetsData.widgets, (widget) ->
          if widget.type in widgetsForEmail
            self.widgetList.push widget

        self.widgetList = WidgetsSortHelper.sortWidgetsByTypesSortMap(self.widgetList, widgetsTypesSortMap)

        $timeout ->
          cb()
    defaultFonts: Font.defaults
    widgetList: []
  }

  # Editor set globally

  $rootScope.Editor = Editor
  window.Editor = Editor

  setGradient = (background_attributes) ->
    color_start = background_attributes.color_start
    color_stop = background_attributes.color_stop
    gradient_css = "
      background-image:-moz-linear-gradient(top, #{color_start}, #{color_stop});
      background-image:-webkit-linear-gradient(top, #{color_start}, #{color_stop});
      background-image:-o-linear-gradient(top, #{color_start}, #{color_stop});
      background-image:-ms-linear-gradient(top, #{color_start}, #{color_stop});,
      background-image:linear-gradient(top, #{color_start}, #{color_stop});
      filter: progid:DXImageTransform.Microsoft.gradient(startColorStr='#{color_start}', endColorstr='#{color_stop}');"
    if $("style##{$rootScope.currentPage.id}").length > 0
      $("style##{$rootScope.currentPage.id}").html "#tpl-wrapper:before { #{gradient_css} }"
    else
      $('body').append("<style id='#{$rootScope.currentPage.id}'>#tpl-wrapper:before { #{gradient_css} }</style>");

  setBgStyles = ->
    bodyElement = $("#tpl-wrapper")
    bodyElement.css $rootScope.currentPage.style_attributes
    imageExist = $rootScope.currentPage.background_attributes and $rootScope.currentPage.background_attributes.image_attributes and $rootScope.currentPage.background_attributes.image_attributes.source_url
    if imageExist
      bodyElement.css {backgroundImage: "url('#{$rootScope.currentPage.background_attributes.image_attributes.source_url}')"}
    if $rootScope.currentPage.background_attributes and $rootScope.currentPage.background_attributes.gradient
      setGradient $rootScope.currentPage.background_attributes
    Parallax.initSection $rootScope.Y.one("#tpl-wrapper")
    return

  # Get json current page

  currentPage = (site) ->
    currentPage = undefined
    pageId = $state.params.pageId
    parentPagesResult = _.filter(site.pages, path: $state.params.pageId)[0]
    currentPage = parentPagesResult if parentPagesResult
    site.pages.forEach (page) ->
      page.pages.forEach (pageChild) ->
        currentPage = pageChild if pageChild.path is pageId
    return currentPage


  # Init drag&drop widgets in widget menu after render

  destroyWidgetsFinished = $scope.$on "widgetsFinished", (newData) ->
    insertBlockMenu.initDD()

  # Destroy instances when exit from editor

  $scope.$on "$destroy", ->
    unbindPreventForm()
    destroyGetStyles()
    destroyWidgetsFinished()
    Editor.destroy()
    TimeMachine.destroy()
    $rootScope.widgetIsEditing = false
    $scope.templateIsReady = false

  # Connect and initialize YUI library Y instance, Editor initialize, Instrumentations init

  if !$rootScope.Y
    YUI().use 'node', 'event-valuechange', 'anim', 'dd', 'dd-proxy', 'dd-constrain', 'dd-drop', 'dd-scroll', "dd-delegate", "event-hover", "resize", "resize-plugin", "overlay", (y) ->
      $rootScope.Y = y
      Editor.initializer()
  else
    Editor.initializer()

  # Show or hide drop overlays of footer or header

  $rootScope.toggleCommonSections = (sections) ->
    sections = Editor.getSections()
    headers = _.filter sections, {section_type: "header"}
    footers = _.filter sections, {section_type: "footer"}

    # Скрываем header и footer
    $scope.showFooter = false
    $scope.showHeader = false

    $scope.$apply() if !$scope.$$phase
  $scope.viewSite = State.viewSite
  $scope.saveSection = editorDragPanel.cancelSection
  $rootScope.openEditorNavPanel = ->
    $(".etsw-header__title").text $filter('translate')('editor.addElementButton')
    $scope.editorNavOpen = true
  $scope.openEditorNav = ->
    $rootScope.editorNavTab "sections"
    $rootScope.openEditorNavPanel()
  $scope.panelRight = true
  $scope.togglePanelPosition = ->
    $scope.panelRight = !$scope.panelRight

  $rootScope.initWidgets = ->
    $rootScope.Y.all(".str-section").each (sectionNode) ->
      $rootScope.initSectionWidgets(sectionNode)

  $rootScope.initSectionWidgets = (sectionNode) ->
    sectionNode.all(".str-block").each (block) ->
      if block.widget and block.widget.type is 'image'
        ImageInit.updateOptions(block.widget)
      if block.widget and block.widget.type is 'link'
        ButtonActionsManager.updateOptions block.widget
      if block.widget and block.widget.type is 'button'
        ButtonActionsManager.updateOptions block.widget
      if block.widget and block.widget.type is 'card'
        ButtonActionsManager.updateOptions block.widget
      if block.widget and block.widget.type is 'product'
        block.widget.product_items_attributes.map (subWidget, id) ->
          if subWidget.item_type is 'button'
            ButtonActionsManager.updateOptions block.widget.product_items_attributes[id]

      layoutEditor.updateSectionEtag(sectionNode.section);

  $rootScope.undo = ->
    $timeout ->
      TimeMachine.undo()

  $rootScope.redo = ->
    $timeout ->
      TimeMachine.redo()

  $rootScope.savePreview = ->
    $scope.loading = true

    layoutEditor.sortSections()

    sections = Editor.getSections()
    SectionEmail.saveAllSectionsAndPublishPreview(sections).then (response) ->
      if response.status and response.data? and response.data.preview_email_id?
        $scope.loading = false
        $rootScope.openPreview response.data.preview_email_id
    , ->
      $scope.loading = false
      Notification.error message: $filter('translate')('site.error')

  # publish site

  $scope.publishSite = ->
    $timeout ->
      $scope.publishing = true

      layoutEditor.sortSections()

      sections = Editor.getSections()
      # for section in sections
      #   if !section.hasOwnProperty("hidden")
      #     section.hidden = false
      SectionEmail.saveAllSectionsAndPublish(sections).then (sectionsData) ->
        EditorLibrary.showBuildStatus(SectionEmail, $scope, null, 3000, 3000, 3);
        TimeMachine.clear()
        layoutEditor.setTemplateJSON sectionsData
        $timeout ->
          $scope.publishing = false
          Notification.success message: $filter('translate')('email.saved')
        , 300
      , ->
        $scope.publishing = false
        Notification.error message: $filter('translate')('site.error')
    , 300

  $scope.sectionSave = ->
    $scope.sectionSaving = true
    layoutEditor.publicSectionSave().then ->
      $scope.sectionSaving  = false
    return

  # Exit from editor

  $scope.exit = ->
    $rootScope.alertDialog
      title: $filter("translate")("alert.editor.exitTitle")
      text: $filter("translate")("alert.editor.exitDescription")
      accept_text: $filter("translate")("alert.confirm")
      cancel_text: $filter("translate")("alert.cancel")
      accept: ->
        if window.justclick.currentUser.role in ["admin", "superadmin"]
          $state.go "admin.dashboard.templates"
        else
          document.location.href = window.justclick.back_uri
]



// WEBPACK FOOTER //
// ./src/app/editor/editorEmail.controller.coffee